module.exports = __webpack_public_path__ + "img/guanyuyou.f12a7edf.png";